module.exports = __webpack_public_path__ + "static/media/arrival-icon.2256774a.svg";